import React, { FC } from 'react';
import { Paragraph } from '../../../../shared/components';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import {
  AddWysiwygBlockButton,
  AddIFrameBlockButton,
  AddVideoBlockButton,
  AddExerciseBlockButton,
} from '../AddBlockButton';
import { useParams } from 'react-router';
import { UrlParams } from '../../../../shared/types';

type Props = {
  id: string;
};

const EmptyPage: FC<Props> = ({ id }) => {
  const { t } = useTranslation();
  const { bookId } = useParams<UrlParams>();

  return (
    <>
      <Paragraph>{t('trajectory.page.empty.intro')}</Paragraph>
      <Grid container spacing={3} alignItems="stretch">
        <Grid xs={6} sm={3} item>
          <AddWysiwygBlockButton viewMode="emptyPage" pageId={id} bookId={bookId!!} />
        </Grid>
        <Grid xs={6} sm={3} item>
          <AddIFrameBlockButton viewMode="emptyPage" pageId={id} bookId={bookId!!} />
        </Grid>
        <Grid xs={6} sm={3} item>
          <AddVideoBlockButton viewMode="emptyPage" pageId={id} bookId={bookId!!} />
        </Grid>
        <Grid xs={6} sm={3} item>
          <AddExerciseBlockButton viewMode="emptyPage" pageId={id} bookId={bookId!!} />
        </Grid>
      </Grid>
    </>
  );
};

export default EmptyPage;
